import React from 'react'

import { useI18n } from '@affiliate-cabinet/i18n'
import { FilterButtons as FilterButtonsComponent } from '@affstore-ds/uikit'

import { filtersTranslationKeys } from '../../shared/translations/filters.translationKeys'
import { FilterButtonsPropertiesInterface } from './FilterButtons.types'

export const FilterButtons = ({ filters, form, resetFormValues, ...rest }: FilterButtonsPropertiesInterface) => {
  const { i18n } = useI18n()

  const handleClearAll = () => {
    form.setValues(resetFormValues)
    form.resetDirty(resetFormValues)
    form.resetTouched()
  }

  return (
    <FilterButtonsComponent
      clearAllButtonText={i18n.t(filtersTranslationKeys.statisticsFiltersClearAll)}
      filters={filters}
      formValues={form.values}
      onClearAll={handleClearAll}
      resetFormValues={resetFormValues}
      submitButtonText={i18n.t(filtersTranslationKeys.statisticsFiltersApplyFilters)}
      {...rest}
    />
  )
}
